/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import queryString from 'query-string'

import { PAGE_COMPONENTS_LOADED } from '_global/js/main'
import { TITLE_CLICK } from 'components/MobileResultsHeader'
import { FILTER_CLICK, SORT_CLICK } from 'components/CompactResultsControls'

import {
  search,
  ON_SEARCH,
  SEARCH_RESULTS
} from 'libs/rcmSearchApi'

import './styles.scss'

class ProductSearch {
  constructor (element) {
    this.$el = $(element)

    this.resultsFilterModal = null
    this.compactResultsControls = null
    this.sidebarFilters = null

    this.$categoryNav = this.$el.find('.productSearch-nav')

    this.collection = this.$el.attr('data-collection')
    this.isStorewideSearch = (this.$el.attr('data-storewide') === 'true')
    this.isFirstSearch = true
    this.isModalOpen = false
    this.defaultSort = this.$el.attr('data-default-sort')

    this.openModal = this.openModal.bind(this)

    search.on(ON_SEARCH, (data) => {
      this.closeModal()

      if (!this.isFirstSearch) {
        const $header = $('#shopify-section-header')
        $('html, body').animate({
          scrollTop: $header.offset().top + $header.height()
        }, 300)
      }
      this.isFirstSearch = false
    })

    search.on(SEARCH_RESULTS, this.onSearchResults.bind(this))

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      search.init({
        returnFacets: true,
        collection: this.collection,
        defaultSort: this.defaultSort
      })

      this.initializeSubComponents()
    })

    this.updateNav()
  }

  initializeSubComponents () {
    // Sync up the header nav with the modal options
    $('.mobileResultsHeader').on(TITLE_CLICK, () => {
      this.openModal(this.$categoryNav)
    })

    this.resultsFilterModal = this.$el.find('.resultsFilterModal').data('component')

    // Sync up the compact results controls with their modals
    this.sidebarFilters = this.$el.find('.sidebarFilters').data('component')

    this.compactResultsControls = this.$el.find('.compactResultsControls').data('component')
    this.compactResultsControls.$el.on(FILTER_CLICK, () => {
      this.sidebarFilters.waitForApply()

      this.openModal(
        this.sidebarFilters.$el,
        this.sidebarFilters.applyFilters,
        this.sidebarFilters.cancelFilters
      )
    })
    this.compactResultsControls.$el.on(SORT_CLICK, () => {
      this.openModal(
        this.compactResultsControls.getModalSortList(),
        this.compactResultsControls.applySort,
        this.compactResultsControls.cancelSort
      )
    })
    this.compactResultsControls.setButtons({
      hasFilter: (this.$el.find('.sidebarFilters').length > 0),
      hasSort: true
    })
  }

  onSearchResults () {
    // put the focus back to the top of the page
    this.$el.find('.productSearch-gap').focus().blur()
  }

  updateNav () {
    // update the collections navigation with the search term, if it exists

    const parsedQuery = queryString.parse(window.location.search)
    if (!parsedQuery.q) {
      return
    }

    if (!this.$categoryNav.length) {
      return
    }

    this.$categoryNav.find('.productSearch-navLink').each((index, element) => {
      const $element = $(element)
      $element.attr('href', $element.attr('href') + `?q=${parsedQuery.q}`)
    })
  }

  openModal ($modalContent, onApply, onCancel) {
    if (this.isModalOpen) {
      this.closeModal()
    }
    const $holder = $('<div></div>')
    $holder.insertAfter($modalContent)

    this.resultsFilterModal.openModal($modalContent, onApply, onCancel, () => {
      $modalContent.detach()
      $modalContent.insertAfter($holder)
      $holder.remove()
      this.isModalOpen = false
    })
    this.isModalOpen = true
  }

  closeModal () {
    if (this.isModalOpen) {
      this.resultsFilterModal.closeModal()
    }
  }
}

registerClass('ProductSearch', ProductSearch)
